window.api_calls = async function (sfid, custid, anaToken) {
  
  let totalDeviceCount = null;

  const authHeaders = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + anaToken
  };
  

  try {
    async function checkOkAndJson(r, label) {
      
      try {
        for (const [k, v] of r.headers.entries()) {
          console.log(`${k}: ${v}`);
        }
      } catch (e) {
        console.warn("Could not read response headers", e);
      }

      const text = await r.text();

      if (!r.ok) {
        const err = new Error(
          label + " HTTP " + r.status + (text ? ": " + text.slice(0, 500) : "")
        );
        err.status = r.status;
        err.body = text;
        console.error("API error:", err);
        
        throw err;
      }

      try {
        const json = text ? JSON.parse(text) : null;
       
        return json;
      } catch (e) {
        console.error("Invalid JSON received:", text.slice(0, 200));
       
        throw e;
      }
    }

    const body = { SFID: sfid, CUSTID: custid };

    // SERVER / HOST LOG (NO LOGIC CHANGE)
    try {
      const apiUrl = window.api_url_get_details_data;
      const u = new URL(apiUrl, window.location.origin);
      
    } catch (e) {
      console.warn("URL parse failed", e);
    }

    const fetchStart = performance.now();

    const data = await fetch(window.api_url_get_details_data, {
      method: "POST",
      headers: authHeaders,
      body: JSON.stringify(body),
    })
      .then(r => {
        const fetchEnd = performance.now();
        return checkOkAndJson(r, "getdetailsdata");
      })
      .catch(err => {
        console.error(
          "api_calls: getdetailsdata failed:",
          window.api_url_get_details_data,
          err
        );
        throw err;
      });

 

    const dd = data && data.device_details;
 

    if (!dd || String(dd.status) !== "200") {
      showErrorPopup('An error has occured. Please try later or email buy@netradyne.com.');
    }

    totalDeviceCount = dd != null ? dd.total_device_count : null;


    if (totalDeviceCount != null) {
      localStorage.setItem("total_device_count", String(totalDeviceCount));

    }

    const subscribedSkus =
      data &&
      data.subscriber_list &&
      Array.isArray(data.subscriber_list.subscribed_products)
        ? data.subscriber_list.subscribed_products
        : [];

    

    const containsFree = subscribedSkus.some(function (sku) {
      const match =
        String(sku) === window.PREM_REPORT ||
        String(sku).indexOf(window.PREM_REPORT) !== -1;
      
      return match;
    });

   
    prem_freebie_toggle(containsFree, totalDeviceCount);

    localStorage.setItem("fetchData", JSON.stringify(data));

  } catch (error) {
    console.error("api_calls ERROR:", error);

    document.cookie =
      "mySessionFlag=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    showErrorPopup('An error occurred. Please email buy@netradyne.com or try later.');

  } finally {
    localStorage.setItem('fetchDone', 'true');
    sessionStorage.setItem('apiCallsDoneThisSession', 'true');
    document.dispatchEvent(new Event('apiCallsComplete'));

  }
};


function showOowElement(oowElement, sumD2, sumD4) { 
      let url = window.location.href;
      let textElement = oowElement.querySelector("span");
      if (url.includes("d-2")) {
        prependSumOnce(textElement, sumD2);
      }
      else if (url.includes("d-4")) {
        prependSumOnce(textElement, sumD4);
      }
} 


function prependSumOnce(textElement, sum) {
  const prefix = String(sum) + " ";
  const current = textElement.textContent ?? "";
  if (!current.startsWith(prefix)) {
    textElement.textContent = prefix + current;
  }
}

// Control the visibility of the freebie indicator on storefront or PDP depending on where the user is during the API_call
function prem_freebie_toggle(containsFree, totalDeviceCount){
        const prem_report = document.getElementById('prem_report_card');
        const prem_box = document.getElementById('prem_reports_box');
        const prem_report_card = document.getElementById('prem_report_card');

        if (containsFree) {
          if (prem_report) prem_report.style.display = "none";
          if (prem_box) prem_box.style.display = "none";
          if (prem_report_card) prem_report_card.style.display = "none";
        } else if (!containsFree && Number(totalDeviceCount) >= 200) {
         
          if (prem_report) prem_report.style.display = "block";
          if (prem_box) prem_box.style.display = "block";
          if (prem_report_card) prem_report_card.style.display = "block";
    
        }
      }

// Create the showError popup when called
function showErrorPopup(message) {          
  // Create overlay          
  var overlay = document.createElement("div");          
  overlay.className = "error-popup-overlay";   
  overlay.innerHTML = " ";   
      
  // Create div          
  var popupDiv = document.createElement("div");          
  popupDiv.className = "error-popup-popupDiv";    
          
  // Create p          
  var popupText = document.createElement("p");          
  popupText.className = "error-popup-popupText";    
      
  // Replace newline character with <br> for HTML        
  message = message.replace(/\n/g, "<br>");        
  popupText.innerHTML = message;          
  popupDiv.appendChild(popupText);          
    
  // Create button container    
  var buttonContainer = document.createElement("div");    
  buttonContainer.className = "button-container";      
    
  // Create button          
  var popupButton = document.createElement("button");          
  popupButton.className = "error-popup-popupButton";    
  popupButton.innerText = "OK";          
  popupButton.addEventListener('click', function () {          
    document.body.removeChild(popupDiv);          
    document.body.removeChild(overlay);      
    window.location.href = IDMS_REDIRECTION;      
  });    
    
  // Add button to button container    
  buttonContainer.appendChild(popupButton);    
      
  // Add button container to popup div    
  popupDiv.appendChild(buttonContainer);   
  
  // Append to body          
  document.body.appendChild(overlay);          
  document.body.appendChild(popupDiv);         
} 

function showPopupforTimeout(message) {              
  // Create overlay              
  var overlay = document.createElement("div");              
  overlay.className = "error-popup-overlay";       
  overlay.innerHTML = " ";       
          
  // Create div              
  var popupDiv = document.createElement("div");              
  popupDiv.className = "error-popup-popupDiv";        
              
  // Create p              
  var popupText = document.createElement("p");              
  popupText.className = "error-popup-popupText";        
          
  // Replace newline character with <br> for HTML            
  message = message.replace(/\n/g, "<br>");            
  popupText.innerHTML = message;              
  popupDiv.appendChild(popupText);              
        
  // Create button container        
  var buttonContainer = document.createElement("div");        
  buttonContainer.className = "button-container";          
        
  // Create button              
  var popupButton = document.createElement("button");              
  popupButton.className = "error-popup-popupButton";        
  popupButton.innerText = "OK";              
  popupButton.addEventListener('click', function () {              
    location.reload(); // refresh the page  
  });        
        
  // Add button to button container        
  buttonContainer.appendChild(popupButton);        
          
  // Add button container to popup div        
  popupDiv.appendChild(buttonContainer);       
      
  // Append to body              
  document.body.appendChild(overlay);              
  document.body.appendChild(popupDiv);             
}   

window.share_cart_call = function(sfid, custid, anaToken, cart_details, input_value) {

 
  var b = 'Bearer ' + anaToken;


  return fetch(window.api_url_share_cart, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + anaToken
        },
    body: JSON.stringify({
      SFID: sfid,
      CUSTID: custid,
      cart_details: cart_details,
      sent_to_email: input_value
    })
  })
  .then(response => {

    if (!response.ok) {
      console.error("API returned error status:", response.status);
    }
    return response.json();
  })
  .then(data => {
    return data;
  })
  .catch(error => {
    console.error("Network or Fetch Error:", error);
  });
};
